import type { LoaderFunction } from 'react-router';

import { getAuthStatus } from 'src/core/utils/authUtil';
import {
  fetchAllGroups,
  type fetchAllGroupsParams,
} from 'src/services/categoriesService';
import type { RouteProps } from 'src/types';

export const appLoader =
  ({ config, client }: RouteProps): LoaderFunction =>
  async ({}) => {
    const isServer = typeof window === 'undefined';
    const isAuthenticated = await getAuthStatus();

    if (isServer) {
      const param: fetchAllGroupsParams = {
        config,
        hasLearningProfile: false,
        client,
      };
      const categoryGroups = await fetchAllGroups(param);

      return { categoryGroups };
    }

    const param: fetchAllGroupsParams = {
      config,
      hasLearningProfile: isAuthenticated,
    };
    const categoryGroups = await fetchAllGroups(param);

    return { categoryGroups };
  };
